import {
  Button,
  Popover,
  PopoverSurface,
  PopoverTrigger,
  makeStyles,
  mergeClasses,
  tokens,
} from "@fluentui/react-components";
import {
  ChevronDown16Regular,
  ChevronUp16Regular,
} from "@fluentui/react-icons";
import React, { useState } from "react";
import styles from "../index.module.css";
import { FrontendAddonUsageOrg } from "../types";

const TRIGGER_COLOR = "var(--figma-color-theme-primary)";
const TRIGGER_OPEN_BACKGROUND = "#1f56e31a";

// Fluent Button は hover / active で文字色と背景を変えるため、開閉どちらの状態でも同じ見た目に固定する
const useStyles = makeStyles({
  trigger: {
    color: TRIGGER_COLOR,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightBold,
    ":hover": { color: TRIGGER_COLOR },
    ":hover:active": { color: TRIGGER_COLOR },
  },
  triggerOpen: {
    backgroundColor: TRIGGER_OPEN_BACKGROUND,
    ":hover": { backgroundColor: TRIGGER_OPEN_BACKGROUND },
    ":hover:active": { backgroundColor: TRIGGER_OPEN_BACKGROUND },
  },
});

const OrgRows: React.FC<{ orgs: FrontendAddonUsageOrg[] }> = ({ orgs }) => (
  <>
    {orgs.map((org) => (
      <div className={styles.usageOrgsRow} key={org.org_id}>
        <div className={styles.usageOrgsRowName}>{org.name}</div>
        <div className={styles.usageOrgsRowId}>ID : {org.org_id}</div>
      </div>
    ))}
  </>
);

// 「利用組織数」セル。クリックで直接指定と latest 指定に分けた利用組織一覧を開く
export const UsageOrgsPopover: React.FC<{
  directUsageOrgs: FrontendAddonUsageOrg[];
  latestUsageOrgs: FrontendAddonUsageOrg[];
}> = ({ directUsageOrgs, latestUsageOrgs }) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerStyles = useStyles();
  const totalCount = directUsageOrgs.length + latestUsageOrgs.length;

  if (totalCount === 0) return <>—</>;

  return (
    <Popover
      open={isOpen}
      onOpenChange={(_, data) => setIsOpen(data.open)}
      positioning="below"
    >
      <PopoverTrigger disableButtonEnhancement>
        <Button
          appearance="subtle"
          size="small"
          className={mergeClasses(
            triggerStyles.trigger,
            isOpen && triggerStyles.triggerOpen
          )}
          icon={isOpen ? <ChevronUp16Regular /> : <ChevronDown16Regular />}
          iconPosition="after"
        >
          {totalCount} 組織
        </Button>
      </PopoverTrigger>
      <PopoverSurface className={styles.usageOrgsPopover}>
        <div className={styles.usageOrgsPopoverTitle}>利用組織一覧</div>
        <div className={styles.usageOrgsListBox}>
          {directUsageOrgs.length > 0 ? (
            <>
              <div
                className={`${styles.usageOrgsGroupHeader} ${styles.usageOrgsGroupHeaderDirect}`}
              >
                <span>直接指定 {directUsageOrgs.length}件</span>
                <span className={styles.usageOrgsGroupHeaderNote}>
                  このバージョンを削除できません
                </span>
              </div>
              <OrgRows orgs={directUsageOrgs} />
            </>
          ) : null}
          {latestUsageOrgs.length > 0 ? (
            <>
              <div
                className={`${styles.usageOrgsGroupHeader} ${styles.usageOrgsGroupHeaderLatest}`}
              >
                <span>latest指定 {latestUsageOrgs.length}件</span>
              </div>
              <OrgRows orgs={latestUsageOrgs} />
            </>
          ) : null}
        </div>
      </PopoverSurface>
    </Popover>
  );
};
